import React from "react"
import Slider from "./Slider"
import PostSaleProduct from "./PostSaleProduct";
import PostSaleProductPlaceholder from "./PostSaleProductPlaceholder";
import SliderComponent from "../../../Gamification2026Template/Home/PostFeed/SliderComponent";


const uuid = require('uuid/v1')

const SaleSlider = ({ sales, backgroundColor, textColor, borderColor, numOfProducts, key }) => {
  const colors = { backgroundColor, textColor, borderColor}
  
  const placeholderProducts = []
  for( var i=0; i < numOfProducts - sales.length; i++){  
    placeholderProducts.push(<PostSaleProductPlaceholder colors = {colors} key={i}/>)
  }

  return (
    <SliderComponent key={key} direction={'center'} sliderId={uuid()} >
      { sales.map(sale => {
          return (
            <PostSaleProduct saleProduct={sale} colors = {colors} key={sale.id}/>
          )
        })
      }
      {
        placeholderProducts
      }
    </SliderComponent>
  )
}

export default SaleSlider
